/**
 * Deployed-build provenance, injected at build time via Vite `define`
 * (see vite.config.ts). Falls back to "unknown" in dev / when unset.
 */

export const REPO_URL = "https://github.com/ghostinator/catalogkit";

export interface BuildInfo {
  commit: string;
  commitShort: string;
  timestamp: string;
  buildUrl: string | null;
  repoUrl: string;
  commitUrl: string | null;
}

export function getBuildInfo(): BuildInfo {
  const commit = import.meta.env.VITE_GIT_COMMIT ?? "unknown";
  const timestamp = import.meta.env.VITE_BUILD_TIMESTAMP ?? "unknown";
  const buildUrl = import.meta.env.VITE_BUILD_URL ?? null;
  const known = commit !== "unknown" && commit !== "";
  return {
    commit,
    commitShort: known ? commit.slice(0, 8) : "unknown",
    timestamp,
    buildUrl,
    repoUrl: REPO_URL,
    commitUrl: known ? `${REPO_URL}/commit/${commit}` : null,
  };
}
